/**
 * Configuración de banners para el Hero
 * 
 * IMPORTANTE: Esta es una configuración temporal.
 * En el futuro, esta data vendrá del backend a través de una API.
 * 
 * La estructura está diseñada para ser compatible con respuestas del backend.
 */

import bannerDesktop from '../../../assets/banner-desktop.png';
import bannerMobile from '../../../assets/banner-mobile.png';

export const bannersConfig = [
  // Banner de Migración a nueva app
  {
    id: 'migration-2026',
    type: 'migration',
    active: true,
    priority: 1,
    
    images: {
      desktop: bannerDesktop,
      mobile: bannerMobile
    },
    
    countdown: {
      enabled: true,
      targetDate: '2026-07-01T00:00:00'
    },
    
    action: {
      type: 'external_link',
      label: 'Descargar App',
      handler: 'https://play.google.com/store/apps/details?id=com.humand.demo',
      subtitle: 'Disponible en Google Play',
      icon: '⬇'
    },
    
    // Preparado para backend
    audience: {
      roles: ['all'],
      users: null,
      departments: null
    },
    
    schedule: {
      start: '2026-01-01',
      end: '2026-07-01'
    },
    
    metadata: {
      createdBy: 'system',
      createdAt: '2026-01-01',
      updatedAt: '2026-06-26'
    }
  },

  // Banner de Organigrama
  {
    id: 'doc-organigrama',
    type: 'document',
    active: true,
    priority: 2,
    
    icon: 'FaSitemap',
    badge: 'ORGANIZACIÓN',
    title: 'Conocé nuestra estructura organizacional',
    description: 'Consultá el organigrama corporativo y conocé cómo está conformado nuestro equipo de trabajo.',
    
    action: {
      type: 'pdf',
      label: 'Ver Organigrama',
      handler: '/assets/organigrama/ORGANIGRAMA.pdf',
      subtitle: 'Abrir documento PDF'
    },
    
    audience: {
      roles: ['all']
    },
    
    schedule: {
      start: null,
      end: null
    }
  },

  // Banner de Política y Visión
  {
    id: 'doc-politica',
    type: 'document',
    active: true,
    priority: 3,
    
    icon: 'FaFileAlt',
    badge: 'NUESTRA EMPRESA',
    title: 'Política, Seguridad y Visión Corporativa',
    description: 'Conocé nuestros valores, compromisos y la visión que nos guía como empresa.',
    
    action: {
      type: 'api_document',
      label: 'Ver Documento',
      handler: 'fetch_active_policy',
      subtitle: 'Política y Visión'
    },
    
    audience: {
      roles: ['all']
    },
    
    schedule: {
      start: null,
      end: null
    }
  }
];

/**
 * Función helper para filtrar banners según usuario/fecha
 * En el futuro, esto se hará en el backend
 */
export const getActiveBanners = (userRole = null) => {
  const now = new Date();
  
  return bannersConfig
    .filter(banner => {
      // Filtrar por activo
      if (!banner.active) return false;
      
      // Filtrar por fecha de inicio
      if (banner.schedule?.start) {
        const startDate = new Date(banner.schedule.start);
        if (now < startDate) return false;
      }
      
      // Filtrar por fecha de fin
      if (banner.schedule?.end) {
        const endDate = new Date(banner.schedule.end);
        if (now > endDate) return false;
      }
      
      // Filtrar por audiencia (si se especifica un rol)
      if (userRole && banner.audience?.roles) {
        if (!banner.audience.roles.includes('all') && !banner.audience.roles.includes(userRole)) {
          return false;
        }
      }
      
      return true;
    })
    .sort((a, b) => (a.priority || 999) - (b.priority || 999));
};

export default bannersConfig;
